import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logoIcon from "../../images/center.png";

export const InitialLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Reveal the site after 2 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          key="acto-loader"
          initial={{ opacity: 1, filter: "blur(0px)" }}
          exit={{ 
              opacity: 0, 
              filter: "blur(40px)",
              scale: 1.1,
              transition: { duration: 1.2, ease: [0.22, 1, 0.36, 1] } 
          }}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "#ffffff", // Pure clean white for logo visibility
            zIndex: 999999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          {/* Liquid Gradient Orb */}
          <motion.div
            animate={{ 
              scale: [1, 1.2, 1],
              rotate: [0, 90, 180, 270, 360],
              borderRadius: ["50%", "40% 60% 70% 30%", "50%", "30% 70% 40% 60%", "50%"]
            }}
            transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
            style={{
              position: "absolute",
              width: "250px", height: "250px",
              background: "linear-gradient(135deg, #0ea5e9, #8b5cf6)",
              filter: "blur(60px)",
              opacity: 0.15, // Softer opacity for light background
              zIndex: 1
            }}
          />

          {/* Central Logo Container */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 10
            }}
          >
              <motion.img
                src={logoIcon}
                alt="ActoLoan"
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                style={{
                  width: "100px",
                  height: "auto",
                  objectFit: "contain",
                  filter: "drop-shadow(0 10px 20px rgba(14, 165, 233, 0.2))",
                  marginBottom: "40px"
                }}
              />
              
              {/* Minimalist Progress Line */}
              <div style={{
                  width: "200px",
                  height: "2px",
                  background: "rgba(0,0,0,0.05)",
                  position: "relative",
                  overflow: "hidden"
              }}>
                  <motion.div 
                    initial={{ x: "-100%" }}
                    animate={{ x: "100%" }}
                    transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        width: "50%",
                        height: "100%",
                        background: "linear-gradient(90deg, transparent, #38bdf8, transparent)",
                        boxShadow: "0 0 10px #38bdf8"
                    }}
                  />
              </div>
              
              <motion.span
                animate={{ opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                style={{
                    marginTop: "15px",
                    color: "#475569", // Darker text for white bg
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "10px",
                    fontWeight: 800,
                    letterSpacing: "8px",
                    textTransform: "uppercase"
                }}
              >
                  ACTOLOAN
              </motion.span>
          </motion.div>

        </motion.div>
      )}
    </AnimatePresence>
  );
};
